var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticStyle: { "overflow-y": "hidden" },
      attrs: { persistent: "" },
      model: {
        value: _vm.dialogGroupMember,
        callback: function($$v) {
          _vm.dialogGroupMember = $$v
        },
        expression: "dialogGroupMember"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card",
            {
              staticStyle: { "box-shadow": "none !important" },
              attrs: { tile: "" }
            },
            [
              _c(
                "v-toolbar",
                {
                  staticStyle: { background: "#2562af !important" },
                  attrs: { card: "" }
                },
                [
                  _vm.state == "editinvite"
                    ? _c(
                        "v-btn",
                        {
                          attrs: { dark: "", icon: "", flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.clearState_back()
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: {
                                color: "white !important",
                                "font-size": "20px !important"
                              }
                            },
                            [_vm._v("chevron_left")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state == "show"
                    ? _c(
                        "v-toolbar-title",
                        { staticClass: "white--text CSChatThai" },
                        [_vm._v("ข้อมูลในกลุ่ม")]
                      )
                    : _c(
                        "v-toolbar-title",
                        { staticClass: "white--text CSChatThai" },
                        [_vm._v("เพิ่มเพื่อนเข้ากลุ่ม")]
                      ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", icon: "", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeDialog()
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            color: "white !important",
                            "font-size": "20px !important"
                          }
                        },
                        [_vm._v("clear")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.state == "show"
            ? _c(
                "v-card-text",
                { staticStyle: { height: "80vh", overflow: "scroll" } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "inline" } },
                    [
                      _c("span", { staticStyle: { "margin-bottom": "2px" } }, [
                        _vm._v(
                          "สมาชิก (" + _vm._s(_vm.groupMember.length) + ")"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticStyle: {
                            margin: "0 !important",
                            float: "right"
                          },
                          attrs: { icon: "", small: "", flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.changestate()
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: {
                                color: "black !important",
                                "font-size": "20px !important",
                                margin: "0 !important"
                              }
                            },
                            [_vm._v("fas fa-plus-circle")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.groupMember.length != 0
                    ? _c(
                        "v-list",
                        [
                          _vm._l(_vm.groupMember, function(item, index) {
                            return [
                              _c(
                                "v-list-tile",
                                {
                                  attrs: { avatar: "" },
                                  on: { click: function($event) {} }
                                },
                                [
                                  _c(
                                    "v-list-tile-avatar",
                                    { attrs: { color: "#2562af", size: "40" } },
                                    [
                                      item.user.profile_picture
                                        ? _c("img", {
                                            staticClass: "alligator-turtle",
                                            attrs: {
                                              src:
                                                _vm.backend +
                                                item.user.profile_picture
                                            }
                                          })
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "white--text headline"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.user.display_name
                                                    .length >= 2
                                                    ? item.user.display_name.charAt(
                                                        0
                                                      ) +
                                                        item.user.display_name.charAt(
                                                          1
                                                        )
                                                    : item.user.display_name.charAt(
                                                        0
                                                      )
                                                )
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c(
                                        "v-list-tile-title",
                                        {
                                          staticClass: "CSChatThai NameBorder"
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(item.user.display_name) +
                                              " \n          "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  item.user.user_id != _vm.user_id
                                    ? _c(
                                        "v-list-tile-action",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "", flat: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeFriendGroup(
                                                    item.user.user_id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    "font-size":
                                                      "20px !important"
                                                  }
                                                },
                                                [_vm._v("clear")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              index != _vm.groupMember.length - 1
                                ? _c("v-divider")
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "margin-bottom": "2px",
                        "margin-top": "6px"
                      }
                    },
                    [
                      _vm._v(
                        "รอการยืนยัน (" + _vm._s(_vm.pendingMember.length) + ")"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.pendingMember.length != 0
                    ? _c(
                        "v-list",
                        [
                          _vm._l(_vm.pendingMember, function(item, index) {
                            return [
                              _c(
                                "v-list-tile",
                                {
                                  attrs: { avatar: "" },
                                  on: { click: function($event) {} }
                                },
                                [
                                  _c(
                                    "v-list-tile-avatar",
                                    { attrs: { color: "#2562af", size: "40" } },
                                    [
                                      item.user.profile_picture
                                        ? _c("img", {
                                            staticClass: "alligator-turtle",
                                            attrs: {
                                              src:
                                                _vm.backend +
                                                item.user.profile_picture
                                            }
                                          })
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "white--text headline"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.user.display_name
                                                    .length >= 2
                                                    ? item.user.display_name.charAt(
                                                        0
                                                      ) +
                                                        item.user.display_name.charAt(
                                                          1
                                                        )
                                                    : item.user.display_name.charAt(
                                                        0
                                                      )
                                                )
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", {
                                        staticClass: "CSChatThai NameBorder",
                                        domProps: {
                                          textContent: _vm._s(
                                            item.user.display_name
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "", flat: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.removePendingFriendGroup(
                                                item.user.user_id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: {
                                                "font-size": "20px !important"
                                              }
                                            },
                                            [_vm._v("clear")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              index != _vm.pendingMember.length - 1
                                ? _c("v-divider")
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm.state == "editinvite"
            ? _c(
                "v-card-text",
                { staticStyle: { "max-height": "80vh", overflow: "scroll" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        padding: "10px",
                        cursor: "pointer",
                        background: "#fafafa"
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                xl12: "",
                                lg12: "",
                                md12: "",
                                sm12: ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  solo: "",
                                  placeholder: "ค้นหาเพื่อน",
                                  "prepend-inner-icon": "fas fa-search",
                                  "hide-details": "",
                                  height: "35"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.searchUser()
                                  }
                                },
                                model: {
                                  value: _vm.searchText,
                                  callback: function($$v) {
                                    _vm.searchText = $$v
                                  },
                                  expression: "searchText"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                xl12: "",
                                lg12: "",
                                md12: "",
                                sm12: ""
                              }
                            },
                            [
                              _vm.stateSearch
                                ? _c(
                                    "div",
                                    [
                                      _vm.listUser.length > 0
                                        ? _c(
                                            "v-list",
                                            {
                                              staticStyle: {
                                                height: "60vh",
                                                overflow: "scroll",
                                                "margin-top": "10px"
                                              },
                                              attrs: { "two-line": "" }
                                            },
                                            [
                                              _vm._l(_vm.listUser, function(
                                                item,
                                                index
                                              ) {
                                                return [
                                                  _c(
                                                    "v-list-tile",
                                                    {
                                                      staticStyle: {
                                                        padding: "0 !important"
                                                      },
                                                      attrs: { avatar: "" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-tile-avatar",
                                                        {
                                                          attrs: {
                                                            color: "#2562af",
                                                            size: "40"
                                                          }
                                                        },
                                                        [
                                                          !item.profile_picture
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "white--text headline"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n              " +
                                                                      _vm._s(
                                                                        item[
                                                                          "display_name"
                                                                        ]
                                                                          .length >=
                                                                          2
                                                                          ? item[
                                                                              "display_name"
                                                                            ].charAt(
                                                                              0
                                                                            ) +
                                                                              item[
                                                                                "display_name"
                                                                              ].charAt(
                                                                                1
                                                                              )
                                                                          : item[
                                                                              "display_name"
                                                                            ].charAt(
                                                                              0
                                                                            )
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            : _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    _vm.backend +
                                                                    item.profile_picture
                                                                }
                                                              })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-content",
                                                        [
                                                          _c(
                                                            "v-list-tile-title",
                                                            {
                                                              staticClass:
                                                                "CSChatThai",
                                                              domProps: {
                                                                textContent: _vm._s(
                                                                  item[
                                                                    "display_name"
                                                                  ]
                                                                )
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-tile-sub-title",
                                                            {
                                                              staticClass:
                                                                "CSChatThai"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n            " +
                                                                  _vm._s(
                                                                    item[
                                                                      "email"
                                                                    ]
                                                                  ) +
                                                                  "\n          "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-action",
                                                        [
                                                          item.group_status ==
                                                          "pending"
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "gray",
                                                                    "font-size":
                                                                      "12px",
                                                                    padding:
                                                                      "5px"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                  เชิญแล้ว\n                "
                                                                  )
                                                                ]
                                                              )
                                                            : item.group_status ==
                                                              "active"
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "gray",
                                                                    "font-size":
                                                                      "12px",
                                                                    padding:
                                                                      "5px"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                  สมาชิก\n                "
                                                                  )
                                                                ]
                                                              )
                                                            : item.group_status ==
                                                              "notactive"
                                                            ? _c(
                                                                "v-btn",
                                                                {
                                                                  staticStyle: {
                                                                    background:
                                                                      "#2663af",
                                                                    margin:
                                                                      "0px",
                                                                    position:
                                                                      "absolute",
                                                                    top: "50%",
                                                                    "-ms-transform":
                                                                      "translateY(-50%)",
                                                                    transform:
                                                                      "translateY(-50%)"
                                                                  },
                                                                  attrs: {
                                                                    small: "",
                                                                    icon: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.inviteUsertoGroup(
                                                                        item.email
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "12px"
                                                                      },
                                                                      attrs: {
                                                                        color:
                                                                          "white"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "fas fa-user-plus "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  index !=
                                                  _vm.listUser.length - 1
                                                    ? _c("v-divider")
                                                    : _vm._e()
                                                ]
                                              })
                                            ],
                                            2
                                          )
                                        : _vm.searchText.length < 3
                                        ? _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "text-align": "center",
                                                "margin-top": "10px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n    ต้องค้นหาตั้งแต่ 3 ตัวอักษรขึ้นไป\n  "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "text-align": "center",
                                                "margin-top": "10px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n    ไม่พบเพื่อนที่ต้องการค้นหา\n  "
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-top": "10px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n    ค้นหาเพื่อนของคุณ จากอีเมลหรือชื่อ\n  "
                                      )
                                    ]
                                  )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03d9acad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03d9acad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/Detail/detail_memberGroup.vue
// module id = null
// module chunks = 